export const ACCESS_LABELS: Record<ShareAccess, string> = {
  private: 'Restricted',
  public: 'Public'
};
export const ACCESS_DESCRIPTION: Record<ShareAccess, string> = {
  private: 'No public access',
  public: 'Anyone with the link can view'
};
